export default __webpack_public_path__ + "static/media/I_Old_White.3dec9420.png";